import PanelTemplate from "components/shared/profile/panel";
import React from "react";
import { showDriverContactListSettings, updateDriverContactListSettings } from "sources/profile/organization";
import { config, initialState } from "./config";

class DriverBidContacts extends PanelTemplate {
    componentDidMount() {
        showDriverContactListSettings().then((data) => this.setState({ data, initial: { ...data } }));
    }

    componentDidUpdate() {
        return undefined;
    }

    renderBody = () => {
        const { profile } = this.props;
        const { availableFeatureModules } = profile;
        const { editable, config } = this.props;
        return (
            <table className="table table-sm">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Тип контакта</th>
                        <th>Название в приложении</th>
                        <th>Скрыть в приложении</th>
                    </tr>
                </thead>
                <tbody>
                    {Object.entries(config)
                        .filter(
                            ([_, item]) =>
                                !item.requiredModule || availableFeatureModules.includes(item.requiredModule),
                        )
                        .map(([key, item], i) => {
                            const onChange = (data) => this.setValue(key, data);
                            return (
                                <tr key={key}>
                                    <td className="align-middle">{i + 1}</td>
                                    <td className="align-middle">{item.title}</td>
                                    <td className="align-middle">
                                        {this.renderField({
                                            ...item.name,
                                            disabled: !editable,
                                            value: this.value(key, item.name.inputProps.name),
                                            onChange,
                                        })}
                                    </td>
                                    <td className="align-middle">
                                        {this.renderCheckbox({
                                            ...item.isHidden,
                                            disabled: !editable,
                                            value: this.value(key, item.isHidden.inputProps.name),
                                            onChange,
                                        })}
                                    </td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        );
    };

    value = (key, name) => this.state.data[key][name];

    update = () => {
        const { shouldUpdate, data } = this.state;
        if (!this.isValidForm(data)) {
            this.props.setIsValid(false);
            return this.setState({ isValid: false });
        }
        if (shouldUpdate) {
            return updateDriverContactListSettings(data).then((res) => {
                if (!res) {
                    this.setState({ isValid: false });
                }
                this.setState({ shouldUpdate: false });
            });
        }
    };

    compareStateAndProps = (_props, data) => {
        for (const key in data) {
            if (this.state.initial[key] !== data[key]) {
                return true;
            }
        }
        return false;
    };

    setValue = (key, { value, name }) => {
        const data = { ...this.state.data, [key]: { ...this.state.data[key], [name]: value } };
        const shouldUpdate = this.compareStateAndProps(this.props.data, data);
        const isValid = this.isValidForm({ ...this.state, [name]: value });
        this.setState({ data, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
        this.props.setIsValid(isValid);
    };

    render() {
        return (
            <>
                {this.renderBody()}
                {this.renderButton()}
            </>
        );
    }
}

const ConfiguredPanel = (props) => <DriverBidContacts {...props} config={config} initialState={initialState} />;

export default ConfiguredPanel;
